import { Flex, Form, InputNumber, Switch } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { TRIP_PRICE } from "../../../utils/constants"
import { useEffect, useState } from "react"
import { spacings } from "themes/variables"
import { ExtraGuestPriceItem } from "../ExtraGuestPriceItem"

export const ExtraGuestsBlock = ({ form, childrenAllowed, infantsAllowed, passengersAllowed }) => {
  const [t] = useTranslation()
  const [allowExtraGuests, setAllowExtraGuests] = useState(form.getFieldValue(TRIP_PRICE.EXTRA_GUESTS_ALLOWED))

  useEffect(() => {
    if (!allowExtraGuests) {
      form.setFieldValue(TRIP_PRICE.PRICE_ADULT, null)
      form.setFieldValue(TRIP_PRICE.PRICE_CHILD, null)
      form.setFieldValue(TRIP_PRICE.PRICE_INFANT, null)
      form.setFieldValue(TRIP_PRICE.PRICE_PASSENGER, null)  
    }

  }, [allowExtraGuests])
  return (
    <Flex vertical gap={spacings.M}>
      <Text variant="sub" size="md">
        {t("experiences.scheduling.sections.length_and_rates.extra_guests")}
      </Text>
      <Flex align="center" gap={spacings.S}>
        <Form.Item name={TRIP_PRICE.EXTRA_GUESTS_ALLOWED} className="mb-0">
          <Switch size="small" onChange={setAllowExtraGuests} />
        </Form.Item>
        <Text variant="body" size="md">
          {t("experiences.scheduling.sections.length_and_rates.allow_extra_guests")}
        </Text>
      </Flex>
      {allowExtraGuests && (
        <Flex vertical>
          <Form.Item
            name={TRIP_PRICE.MAX_EXTRA_GUESTS}
            label={t("experiences.scheduling.sections.length_and_rates.max_additional_guests")}
            rules={[{ required: true, message: t("form_validation.cannot_be_blank") }]}
          >
            <InputNumber size="large" min={0} className="w-100" />
          </Form.Item>
          <Flex vertical gap={spacings.XXS}>
            <Text variant="sub" size="md">
              {t("experiences.scheduling.sections.length_and_rates.additional_charges")}
            </Text>
            <ExtraGuestPriceItem name={TRIP_PRICE.PRICE_ADULT} text={t("experiences.scheduling.sections.length_and_rates.adults")} />
            {childrenAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_CHILD}
                text={t("experiences.scheduling.sections.length_and_rates.children")}
                subText={t("experiences.scheduling.sections.length_and_rates.under_12_years")}
              />
            )}
            {infantsAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_INFANT}
                text={t("experiences.scheduling.sections.length_and_rates.infants")}
                subText={t("experiences.scheduling.sections.length_and_rates.under_2_years")}
              />
            )}
            {passengersAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_PASSENGER}
                text={t("experiences.scheduling.sections.length_and_rates.passengers")}
                infoText={t("experiences.scheduling.sections.length_and_rates.passengers_info")}
              />
            )}
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}

ExtraGuestsBlock.propTypes = {
  form: PropTypes.object.isRequired,
  childrenAllowed: PropTypes.bool,
  infantsAllowed: PropTypes.bool,
  passengersAllowed: PropTypes.bool,
};
